import React, { FC } from 'react'

import StylesModule from 'layout/footer.module.scss'
import DesignButton from 'components/lv1/designButton'
import { MessageProps } from 'message/index.props'
export interface FooterProps {
  message: MessageProps
}

const Footer: FC<FooterProps> = ({ message }) => {
  return (
    <footer className={StylesModule.footer}>
      <div className={StylesModule.footerTop}>
        <div className={StylesModule.footerTop__wrap}>
          <div className={StylesModule.footerTop__info}>
            <div className={StylesModule.footerTop__title}>
              {message.global.westinkyoto.name}
            </div>
            <div
              className={StylesModule.footerTop__address}
              dangerouslySetInnerHTML={{
                __html: message.global.westinkyoto.address,
              }}
            />
            <div className={StylesModule.footerTop__tel}>
              {message.global.westinkyoto.tel}
            </div>
          </div>
          <div className={StylesModule.footerTop__button}>
            <div className={StylesModule.footerTop__hotelButton}>
              <DesignButton
                label={message.global.to_top}
                to={message.global.to_top_button.url}
                design="footer-outline"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={StylesModule.footerBottom}>
        {message.global.copyright}
      </div>
    </footer>
  )
}

export default Footer
